import { Toast } from '@byecode/ui'
import type { ActionFlowNode, CopyActionConfig, CopyActionConfigure, FlowNodeResultADT } from '@lighthouse/shared'
import { generateVariableValue } from '@lighthouse/shared'
import { safeToString } from '@lighthouse/tools'
import copyToClipboard from 'copy-to-clipboard'
import { t } from 'i18next'

import type { ExecuteActionParams } from '../type'

export const handleCopyStream = async (
    node: ActionFlowNode<CopyActionConfigure>,
    params: ExecuteActionParams
): Promise<undefined | FlowNodeResultADT> => {
    const {
        data: { config }
    } = node

    if (!config) {
        throw new Error(t('configurationNotPerfect'))
    }

    const text = handleCopy(config, params)

    return await Promise.resolve({
        type: 'args',
        success: true,
        data: [{ id: '', name: 'text', innerType: 'TEXT', value: text }]
    })
}

export const handleCopy = (config: CopyActionConfig, params: ExecuteActionParams) => {
    const { copyText } = config
    const text = generateVariableValue({
        innerType: 'TEXT',
        jsonContent: copyText,
        extraParams: params,
        options: { format: true, useFileUrl: true }
    })
    if (text) {
        const copyText = safeToString(text)
        copyToClipboard(copyText, { format: 'text/plain' })
        // Toast.success(t('copySuccess'))
    }

    return text
}
